import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaUser, FaLock, FaEye, FaEyeSlash, FaShieldAlt } from 'react-icons/fa';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './AdminLogin.css';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  // Retrieve the redirect path, or default to Careers SuperAdmin
  const from = location.state?.from?.pathname || '/admin/superadmin';

  const handleLogin = (e) => {
    e.preventDefault();
    setLoading(true);

    // Secure credentials configured for iMatrix Authorized Personnel
    // In production, these can be verified against a secure OAuth/Auth0 or database backend.
    const ADMIN_USER = 'admin';
    const ADMIN_PASS = 'iMatrix@2026';

    setTimeout(() => {
      if (username === ADMIN_USER && password === ADMIN_PASS) {
        localStorage.setItem('imatrix_admin_logged', 'true');
        localStorage.setItem('imatrix_admin_user', username);

        toast.success("Authentication successful! Welcome to Admin Console.");
        setTimeout(() => {
          navigate(from, { replace: true });
        }, 1000);
      } else {
        toast.error("Invalid Username or Password! Access Denied.");
        setLoading(false);
      }
    }, 800);
  };

  return (
    <div className="login-root">
      <ToastContainer position="top-right" autoClose={3000} theme="colored" />

      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <div className="shield-icon-wrap">
              <FaShieldAlt />
            </div>
            <h2>Admin Gateway</h2>
            <p>Access restricted to authorized iMatrix corporate personnel only</p>
          </div>

          <form className="login-form" onSubmit={handleLogin}>
            <div className="form-group">
              <label>Username</label>
              <div className="input-icon-wrapper">
                <FaUser className="input-icon" />
                <input
                  type="text"
                  placeholder="Enter administrator username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  disabled={loading}
                />
              </div>
            </div>

            <div className="form-group">
              <label>Password</label>
              <div className="input-icon-wrapper">
                <FaLock className="input-icon" />
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter secure password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  disabled={loading}
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  disabled={loading}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>

            <button type="submit" className="login-submit-btn" disabled={loading}>
              {loading ? "Authorizing Security..." : "Sign In to Admin Portal"}
            </button>
          </form>

          <footer className="login-footer">
            <p>© {new Date().getFullYear()} iMatrix Technologies Pvt Ltd. All rights reserved.</p>
            <p className="footer-notice">Unauthorized access attempts are audited and logged.</p>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
